import axiosInstance from "./axiosInstance";

export async function registerEvent(eventName) {
  const values = [eventName, new Date().toLocaleDateString("de-DE")];

  return axiosInstance.post(
    "https://chevalier.group/webhook/trigger/60b0e4e2913c0d001af422c4",
    { values }
  );
}
